// extracted by mini-css-extract-plugin
export default {"block":"CircularProgressBar_block__N4PU5","completed":"CircularProgressBar_completed__-vcGI"};